<template>
<div class="row">
  <div class="col-md-12">
    <card
      :title="$t('Common.masterdata')"
      :loader="masterdata.loader"
      :alert="masterdata.alert.title"
      :alert-style="masterdata.alert.style"
      :alert-text="masterdata.alert.text"
      :alert-icon="masterdata.alert.icon"
      v-on:dismissalert="closeAlert(masterdata.alert)"
      alert-dismissable
    >
      <form v-on:submit='updateMasterdata' class="form form-horizontal">
        <sect :title="$t('Common.accountDetails')">
          <field :label="$t('Common.customerNum')" name="customernum" v-model="masterdata.form.customernum" disabled></field>
          <template v-if="masterdata.form.firstname">
            <field :label="$t('Common.firstname')" name="firstname" v-model="masterdata.form.firstname" :warning="masterdata.warnings.firstname" :disabled="disableAddressEdit"></field>
            <field :label="$t('Common.lastname')" name="lastname" v-model="masterdata.form.lastname" :warning="masterdata.warnings.lastname" :disabled="disableAddressEdit"></field>
          </template>
          <template v-else>
            <field :label="$t('Common.company')" name="company" v-model="masterdata.form.lastname" :warning="masterdata.warnings.lastname" :disabled="disableAddressEdit"></field>
          </template>
          <field label="E-Mail" name="email" v-model="masterdata.form.email" :warning="masterdata.warnings.email" :disabled="disableAddressEdit"></field>
        </sect>
        <sect :title="$t('Common.contact')">
          <field :label="$t('Common.address')" name="address" v-model="masterdata.form.address" :warning="masterdata.warnings.address" :disabled="disableAddressEdit"></field>
          <field :label="$t('Common.postalcode')" name="postalcode" v-model="masterdata.form.postalcode" :warning="masterdata.warnings.postalcode" :disabled="disableAddressEdit"></field>
          <field :label="$t('Common.city')" name="city" v-model="masterdata.form.city" :warning="masterdata.warnings.city" :disabled="disableAddressEdit"></field>
        </sect>
        <sect :title="$t('Common.taxDetails')">
          <field :label="$t('Common.vatId')" name="vatid" v-model="masterdata.form.vatid" :warning="masterdata.warnings.vatid" :disabled="disableAddressEdit"></field>
        </sect>
        <ProjectMasterDataTab
            :form="masterdata.extra"
            :form-values="masterdata.form"
            :has-order="false"
            :is-editable="true"
            :force-validation="false"
            :item-nums="{}"
            v-on:valid="handleFormStatus"
        />
        <div :class="['expand', {'active': showMasterdataSave}]">
          <div class="form-group">
            <div class="col-md-9 col-md-offset-3">
              <button type="submit" class="btn btn-primary">{{ $t('Action.save') }}</button>
            </div>
          </div>
        </div>
      </form>
    </card>
    <card v-if="!disablePasswordChange" class="mtop-10" :title="$t('Login.password')" :loader="changePwd.loader" :alert="changePwd.alert.title" :alert-style="changePwd.alert.style" :alert-text="changePwd.alert.text" :alert-icon="changePwd.alert.icon" v-on:dismiss="closeAlert(changePwd.alert)" dismissable>
      <form v-on:submit='updatePassword' class="form form-horizontal">
        <field type="password" :label="$t('Login.passwordOld')" name="oldpwd" v-model="changePwd.form.oldpwd"></field>
        <field ref="pwdControl" type="password-advanced" :label="$t('Login.passwordNew')" name="newpwd1" :force-validation="forceValidation" v-model="changePwd.form.newpwd1"></field>
        <field type="password" :label="$t('Login.passwordConfirm')" name="newpwd2" v-model="changePwd.form.newpwd2"></field>
        <div :class="['expand', {'active': showPwdSave}]">
          <div class="form-group">
            <div class="col-md-9 col-md-offset-3">
              <button type="submit" class="btn btn-primary">{{ $t('Action.save') }}</button>
            </div>
          </div>
        </div>
      </form>
    </card>
  </div>
</div>
</template>
<script>
import ProjectMasterDataTab from './ProjectMasterDataTab.vue';

var view = require('../view.js'),
    viewData = {
      'masterdata': {
        'extra': [],
        'form': {
          'customernum': '',
          'firstname': '',
          'lastname': '',
          'company': '',
          'vatid': '',
          'email': '',
          'address': '',
          'postalcode': '',
          'city': ''
        },
        'warnings': {
          'firstname': '',
          'lastname': '',
          'company': '',
          'vatid': '',
          'email': '',
          'address': '',
          'postalcode': '',
          'city': ''
        },
        'loader': '',
        'alert': {
          'title': '',
          'text' : '',
          'style': '',
          'icon' : '',
        }
      },
      'changePwd': {
        'form': {
          'oldpwd': '',
          'newpwd1': '',
          'newpwd2': ''
        },
        'loader': '',
        'alert': {
          'title': '',
          'text' : '',
          'style': '',
          'icon' : '',
        }
      },
      forceValidation: false,
    };

export default view(viewData, {
  components: {
    ProjectMasterDataTab
  },
  computed: {
    showPwdSave() {
      return this.changePwd.form.oldpwd != '' && this.changePwd.form.newpwd1 != '' && this.changePwd.form.newpwd2 != '';
    },
    showMasterdataSave() {
      return this.disableAddressEdit === false || (this.masterdata.extra && this.masterdata.extra.length);
    },
    disableAddressEdit() {
      return typeof this.$root.disableAddressEdit !== 'undefined' ? !!this.$root.disableAddressEdit : false;
    },
    disablePasswordChange() {
      return typeof this.$root.disablePasswordChange !== 'undefined' ? !!this.$root.disablePasswordChange : false;
    }
  },
  mounted() {
    this.$parent.viewTitle = this.$t('Common.settings');

    // Update the user settings
    const user = this.$parent.getUser();
    console.log('user', JSON.stringify(user))
    for (let key in this.masterdata.form) {
      if (this.masterdata.form.hasOwnProperty(key)) {
        if (typeof user[key] != 'undefined') {
          this.masterdata.form[key] = user[key];
        }
      }
    }

    for (let key in user.extdata) {
      if (user.extdata.hasOwnProperty(key)) {
        this.masterdata.form[key] = user.extdata[key];
      }
    }

    this.masterdata.extra = this.$root.userSettingsExtraFields || [];
  },
  methods: {
    updateMasterdata(evt) {
      evt.preventDefault();
      this.masterdata.loader = this.$t('Action.saving');
      this.$http.post(this.$root.url + 'account/', this.masterdata.form).then(function(res) {
          this.masterdata.loader = '';
          this.masterdata.alert.icon  = 'check-circle-o';
          this.masterdata.alert.style = 'success';
          this.masterdata.alert.text  = '';
          this.masterdata.alert.title = this.$t('Common.masterdataSaved');
        }.bind(this),
        function(res) {
          this.masterdata.loader = '';
          this.masterdata.alert.icon  = 'exclamation-triangle';
          this.masterdata.alert.style = 'danger';
          this.masterdata.alert.text  = '';
          this.masterdata.alert.title = this.$t('Common.errorSavingMasterdata');

          if (typeof res.data == 'object' && typeof res.data.code != 'undefined') {
            switch (res.data.code) {
              case 100:
                this.masterdata.alert.text = this.$t('Common.errorIncomplete');
                break;
            }
          }
        }.bind(this));
    },
    updatePassword(evt) {
      evt.preventDefault();

      this.forceValidation = true;

      if (!this.$refs.pwdControl.isValid()) {
        return
      }

      if (this.changePwd.form.newpwd1 !== this.changePwd.form.newpwd2) {
        alert(this.$t('Password.confirmationNoMatch'));
        return;
      }

      this.changePwd.loader = this.$t('Action.saving');

      this.$http.post(this.$root.url + 'auth/password/', this.changePwd.form).then(function(res) {
          this.changePwd.form.oldpwd = '';
          this.changePwd.form.newpwd1 = '';
          this.changePwd.form.newpwd2 = '';
          this.changePwd.loader = '';
          this.changePwd.alert.icon  = 'check-circle-o';
          this.changePwd.alert.style = 'success';
          this.changePwd.alert.text  = '';
          this.changePwd.alert.title = this.$t('Login.passwordSaved');
        }.bind(this),
        function(res) {
          this.forceValidation = false;
          this.changePwd.loader = '';
          this.changePwd.alert.icon  = 'exclamation-triangle';
          this.changePwd.alert.style = 'danger';
          this.changePwd.alert.text  = '';
          this.changePwd.alert.title = this.$t('Login.errorCouldNotUpdate');

          if (typeof res.data == 'object' && typeof res.data.code != 'undefined') {
            switch (res.data.code) {
              case 100:
                this.changePwd.alert.text = this.$t('Common.errorIncomplete');
              case 101:
                this.changePwd.alert.text = this.$t('Login.errorPasswordNoMatch');
                break;
              case 102:
                this.changePwd.alert.text = this.$t('Login.errorNoSession');
                break;
              case 103:
                this.changePwd.alert.text = this.$t('Login.errorOldPassword');
                break;
            }
          }
        }.bind(this));
    },
    closeAlert(alert) {
      alert.title = '';
      alert.text  = '';
      alert.style = '';
      alert.icon  = '';
    },
    handleFormStatus(isValid) {
      console.log(isValid)
    }
  }
});
</script>
